import LoaderSvg from '~assets/icons/loader.svg'

import { Box } from '@mui/material'

export const AnimatedLoader = () => {
	return (
		<Box
			sx={{
				'display': 'inline-flex',
				'animation': 'spin 2s linear infinite',
				'fontSize': 80,
				'@keyframes spin': {
					'0%': { transform: 'rotate(0deg)' },
					'100%': { transform: 'rotate(360deg)' }
				}
			}}
		>
			<LoaderSvg fontSize='inherit' color='primary' />
		</Box>
	)
}
